import { createContext, useContext, type ReactNode } from "react";

/**
 * "BU SEKME ŞU AN ÖNDE Mİ?" bağlamı.
 *
 * ── Neden gerekli ──
 * Çoklu sekmede tüm açık sayfalar AYNI ANDA mount kalır (yarım form kaybolmasın diye).
 * Sekme panelini `display:none` ile gizlemek YETMEZ: Drawer, ConfirmDialog, SearchSelect
 * paneli, dosya önizleme ve işlem overlay'i `createPortal(document.body)` ile #root'un
 * KARDEŞİ olarak basılır — panelin gizlenmesi onlara ulaşmaz. Gizli bir sekmenin açık
 * drawer'ı aktif sekmenin üstünde durmaya devam ederdi.
 *
 * ── Çözümün özü: DOM'u düşür, DURUMU tut ──
 * Katman bileşenleri pasif sekmede `null` döner. Böylece portal DOM'u yok olur; ama
 * katmanı AÇAN durum (hangi kayıt açık, forma ne yazıldı) sayfanın kendi React state'inde
 * yaşamaya devam eder. Sekmeye dönüldüğünde panel AYNI değerlerle yeniden çizilir.
 * Alternatif (sekme başına portal kabı) hem daha pahalı hem daha kırılgandı: z-index
 * yığını, ESC sahipliği ve odak tuzağı hâlâ sekmeler arası karışırdı.
 *
 * Sekme sistemi DIŞINDA (baskı sayfaları, giriş ekranı, mobil kabuk) varsayılan `true`
 * — yani bağlam yoksa her şey normal render edilir.
 */
const TabActiveContext = createContext<boolean>(true);

export function TabActiveProvider({ active, children }: { active: boolean; children: ReactNode }) {
  return <TabActiveContext.Provider value={active}>{children}</TabActiveContext.Provider>;
}

/** Bu ağaç ÖNDEKİ sekmede mi? Katman bileşenleri render kararını buna bağlar. */
export function useTabActive(): boolean {
  return useContext(TabActiveContext);
}
